import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { APIProvider } from "@vis.gl/react-google-maps";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import Landing from "@/pages/Landing";
import BookingPage from "@/pages/BookingPage";
import BookingSuccess from "@/pages/BookingSuccess";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import Legal from "@/pages/Legal";
import VerifyEmail from "@/pages/VerifyEmail";
import InstallPWA from "@/components/InstallPWA";

const GMAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const Protected = ({ children, admin }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background" />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

function getVisitorId() {
  let v = localStorage.getItem("visitor_id");
  if (!v) {
    v = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("visitor_id", v);
  }
  return v;
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    api.post("/track", { path: location.pathname, visitor_id: getVisitorId() }).catch(() => {});
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App grain">
      <APIProvider apiKey={GMAPS_KEY} libraries={["places", "routes"]}>
        <AuthProvider>
          <BrowserRouter>
            <PageTracker />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/booking/success" element={<BookingSuccess />} />
              <Route path="/book" element={<BookingPage />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/privacy" element={<Legal doc="privacy" />} />
              <Route path="/terms" element={<Legal doc="terms" />} />
              <Route path="/cancellation-policy" element={<Legal doc="cancellation" />} />
              <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
              <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <InstallPWA />
        </AuthProvider>
      </APIProvider>
    </div>
  );
}

export default App;
